import PropTypes from "prop-types";

const commonProps = {
  color: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  value: PropTypes.string,
};

const iconPropTypes = PropTypes.shape({
  color: PropTypes.string,
  name: PropTypes.string,
});

const graphicAlignPropType = PropTypes.shape({
  horizontal: PropTypes.oneOf(["left", "right", "center"]),
  vertical: PropTypes.oneOf(["top", "bottom", "middle"]),
});

const textPropType = PropTypes.shape(commonProps);

const sizeShape = PropTypes.shape({
  align: graphicAlignPropType,
  imagePath: PropTypes.string,
});

const overrideShape = {
  large: sizeShape,
  medium: sizeShape,
  small: sizeShape,
};

const backgroundOverrides = {
  large: PropTypes.shape({ imagePath: PropTypes.string }),
  medium: PropTypes.shape({ imagePath: PropTypes.string }),
  small: PropTypes.shape({ imagePath: PropTypes.string }),
};

const offersPlacementPropType = PropTypes.shape({
  background: PropTypes.shape({
    color: PropTypes.string,
    direction: PropTypes.string,
    imagePath: PropTypes.string,
    overrides: PropTypes.shape(backgroundOverrides),
    theme: PropTypes.string,
    type: PropTypes.oneOf(["color", "gradient", "image"]),
  }),

  callToAction: PropTypes.object,

  disclaimer: PropTypes.shape({
    value: PropTypes.string,
  }),

  eyebrow: PropTypes.shape({
    badgeStyle: PropTypes.string,
    badgeype: PropTypes.string,
    prefixIcon: iconPropTypes,
    suffixIcon: iconPropTypes,
    value: PropTypes.string.isRequired,
  }),

  graphic: PropTypes.shape({
    align: graphicAlignPropType,
    altText: PropTypes.string,
    imagePath: PropTypes.string,
    overrides: PropTypes.shape(overrideShape),
  }),

  offerDetails: PropTypes.shape({
    delimiter: PropTypes.shape({
      lineSeparator: PropTypes.shape({
        color: PropTypes.string,
        fontWeight: PropTypes.string,
      }),
      text: PropTypes.shape(commonProps),
    }),
    offers: PropTypes.arrayOf(
      PropTypes.shape({
        bottomCaption: PropTypes.shape(commonProps),
        leadingText: textPropType,
        topCaption: PropTypes.shape(commonProps),
        trailingText: textPropType,
        value: textPropType,
      })
    ),
  }),

  text: PropTypes.shape({
    callout: textPropType,
    primary: textPropType,
    secondary: textPropType,
  }),
});

export { offersPlacementPropType };
